import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/images/page_turning_left.svg'
import _imports_1 from '../assets/images/page_turning_right.svg'


const _withScopeId = n => (_pushScopeId("data-v-c5214e80"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "authority_transfer_bg" }
const _hoisted_2 = { class: "center_content" }
const _hoisted_3 = { class: "post-wrapper" }
const _hoisted_4 = { id: "posterHtml" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "post-link-name" }
const _hoisted_7 = { class: "linkard_tags" }
const _hoisted_8 = { class: "linkard_tags_bg" }
const _hoisted_9 = { class: "post-link-avatar" }
const _hoisted_10 = { class: "qr_code_image_bg" }
const _hoisted_11 = { class: "card_name" }
const _hoisted_12 = { class: "manager_list_bg" }
const _hoisted_13 = {
  key: 0,
  class: "manager_list"
}
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "manager_user_name" }
const _hoisted_16 = { class: "phone_number" }
const _hoisted_17 = { class: "linkard_cnt" }
const _hoisted_18 = {
  key: 1,
  class: "empty_tips"
}
const _hoisted_19 = { class: "manager_list_bottom_view" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_21 = { class: "page_number" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_23 = { class: "bottom_action_bg" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_vue_qrcode = _resolveComponent("vue-qrcode")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("img", {
            src: _ctx.linkardInfo.avatar,
            alt: "",
            class: "post-link-logo"
          }, null, 8, _hoisted_5),
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.linkardInfo.name), 1),
          _createElementVNode("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.linkardInfo.tags, (item, index) => {
              return (_openBlock(), _createElementBlock("div", _hoisted_8, [
                item
                  ? (_openBlock(), _createElementBlock("span", { key: index }, _toDisplayString(item), 1))
                  : _createCommentVNode("", true)
              ]))
            }), 256))
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_el_image, {
              src: _ctx.linkardInfo.npcAvatar,
              fit: "cover"
            }, null, 8, ["src"])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_vue_qrcode, {
              value: _ctx.linkardQRImgUrl,
              color: {},
              type: "image/png",
              width: 32,
              height: 32,
              margin: 2,
              errorCorrectionLevel: "L"
            }, null, 8, ["value"])
          ])
        ])
      ]),
      _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.linkardInfo.name), 1),
      _createElementVNode("div", _hoisted_12, [
        (_ctx.tempManagerList.length > 0)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_13, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tempManagerList, (managerItem, index) => {
                return (_openBlock(), _createElementBlock("li", { key: index }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(['manager_item', !managerItem.transferable ? 'manager_item_disable' : _ctx.currentSelManagerItem == managerItem ? 'manager_item_selected' : 'manager_item_normal']),
                    onClick: ($event: any) => (_ctx.managerItemClick(managerItem))
                  }, [
                    _createElementVNode("span", _hoisted_15, _toDisplayString(managerItem.userName), 1),
                    _createElementVNode("span", _hoisted_16, _toDisplayString(managerItem.tempUserPhone), 1),
                    _createElementVNode("span", _hoisted_17, _toDisplayString(managerItem.transferable ? '已有' + managerItem.linkardCnt + '张'
                        : '未注册'), 1)
                  ], 10, _hoisted_14)
                ]))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("span", _hoisted_18, "暂未添加管理员")),
        _createElementVNode("div", _hoisted_19, [
          _createVNode(_component_el_button, {
            disabled: _ctx.currentManagerPage <= 0,
            class: "page_button",
            onClick: _ctx.pageLeft
          }, {
            default: _withCtx(() => [
              _hoisted_20
            ]),
            _: 1
          }, 8, ["disabled", "onClick"]),
          _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.currentManagerPage + 1), 1),
          _createVNode(_component_el_button, {
            disabled: (_ctx.currentManagerPage + 1) * 5 >= _ctx.managerList.length,
            class: "page_button",
            onClick: _ctx.pageRight
          }, {
            default: _withCtx(() => [
              _hoisted_22
            ]),
            _: 1
          }, 8, ["disabled", "onClick"])
        ])
      ]),
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("button", {
          class: "cancel_button action_button",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.cancleButtonClick && _ctx.cancleButtonClick(...args)))
        }, "取消"),
        _createElementVNode("button", {
          class: "sure_button action_button",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.sureButtonClick && _ctx.sureButtonClick(...args)))
        }, "确认转移")
      ])
    ])
  ]))
}